export function initApplicantsFilters() {
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-expect-error
  const { menloFilters, applicantsFilters } = acfData;

  if (!applicantsFilters) return;

  const displayApplicantsFilters = applicantsFilters.display_applicants_filters;
  const filtersTitle = applicantsFilters.filters_title;
  const applyFiltersText = applicantsFilters.apply_filters_text;
  const resetFiltersText = applicantsFilters.reset_filters_text;
  const filtersPerRow = parseInt(applicantsFilters.filters_row) ?? 4;

  const convertFilterName = function (filterName: string) {
    return filterName.replace(/[^a-z0-9]/g, function (s) {
      const c = s.charCodeAt(0);
      if (c === 32) {
        return '_';
      }
      if (c >= 65 && c <= 90) {
        return s.toLowerCase();
      }
      return '__' + ('000' + c.toString(16)).slice(-4);
    });
  };

  const getSelectedFilters = function () {
    //get all filters by class
    const mcFilters: NodeListOf<HTMLSelectElement> = document.querySelectorAll(
      '.menlo-applicants-filter:not(.hidden)',
    );

    const selectedFilters: HTMLOptionElement[] = [];

    mcFilters.forEach(function (el: HTMLSelectElement) {
      const sel = el.selectedIndex;
      const optionClass: string = el.options[sel].className;
      if ('menlo-filter__label' !== optionClass) {
        selectedFilters.push(el.options[sel]);
      }
    });
    return selectedFilters;
  };

  const getNotSelectedFilters = function () {
    //get all filters by class
    const mcFilters: NodeListOf<HTMLSelectElement> = document.querySelectorAll(
      '.menlo-applicants-filter:not(.hidden)',
    );

    const notSelectedFilters: HTMLSelectElement[] = [];

    mcFilters.forEach(function (el: HTMLSelectElement) {
      const sel = el.selectedIndex;
      const optionClass: string = el.options[sel].className;
      if ('menlo-filter__label' === optionClass) {
        notSelectedFilters.push(el);
      }
    });
    return notSelectedFilters;
  };

  const updateFontWeight = function (element: HTMLSelectElement) {
    if (element.value !== 'default') {
      element.style.fontWeight = '900';
    } else {
      element.style.fontWeight = '400';
    }
  };

  const getAvailableApplicants = function () {
    //get all applicant cards
    const applicantCards: NodeListOf<HTMLElement> = document.querySelectorAll(
      '.wp-block-menlo-applicant-story-card',
    );
    const availableApplicants: HTMLElement[] = [];
    const selectedFilters = getSelectedFilters();

    let filtersParentMarkUp = '';
    let filtersCount = 0;
    selectedFilters.forEach(function (el: HTMLOptionElement) {
      if (el.parentElement && el.parentElement.hasAttribute('id')) {
        const parentId: string = el.parentElement.getAttribute('id') ?? '';
        if (!filtersParentMarkUp.includes(parentId)) {
          filtersParentMarkUp += parentId;
          filtersCount++;
        }
      }
    });

    if (selectedFilters.length) {
      applicantCards.forEach(function (element) {
        let matchedFilters = 0;
        selectedFilters.forEach(function (selectedFilter: HTMLOptionElement) {
          const dataSelector: string = selectedFilter.dataset.filter ?? '';

          if (
            element.hasAttribute(dataSelector) &&
            selectedFilter.value === element.getAttribute(dataSelector)
          ) {
            matchedFilters++;
          }
        });
        if (matchedFilters === filtersCount) {
          availableApplicants.push(element);
        }
      });
    } else {
      return applicantCards;
    }

    return availableApplicants;
  };

  const updateFiltersAvailability = function () {
    const notSelectedFilters = getNotSelectedFilters();
    const availableApplicants = getAvailableApplicants();

    notSelectedFilters.forEach(function (el) {
      const filterOptions = el.options;
      let optionsCount = 0;

      Array.from(filterOptions).forEach(function (optionEl, index) {
        const dataSelector = optionEl.dataset.filter ?? '';
        if (optionEl.dataset.filter) {
          let foundMatch = false;

          availableApplicants.forEach(function (availableApplicant) {
            if (
              availableApplicant.hasAttribute(dataSelector) &&
              optionEl.value === availableApplicant.getAttribute(dataSelector)
            ) {
              foundMatch = true;
            }
          });

          if (!foundMatch) {
            filterOptions[index].className = 'hide-option';
            optionsCount++;
          } else {
            filterOptions[index].classList.remove('hide-option');
          }
        }
      });

      //subtract the default value
      if (optionsCount === filterOptions.length - 1) {
        el.classList.add('disable');
      } else {
        el.classList.remove('disable');
      }
    });
  };

  const resetFilters = function () {
    const mcFilters: NodeListOf<HTMLSelectElement> = document.querySelectorAll(
      '.menlo-applicants-filter:not(.hidden)',
    );

    mcFilters.forEach(function (mcFilter) {
      mcFilter.value = 'default';
      updateFontWeight(mcFilter);
      updateFiltersAvailability();
      applyFilters();
    });
  };

  const applyFilters = function () {
    const selectedFilters = getSelectedFilters();

    //get all applicant cards
    const applicantCards: NodeListOf<HTMLElement> = document.querySelectorAll(
      '.wp-block-menlo-applicant-story-card',
    );

    let filtersParentMarkUp = '';
    let filtersCount = 0;
    selectedFilters.forEach(function (el: HTMLOptionElement) {
      if (el.parentElement && el.parentElement.hasAttribute('id')) {
        const parentId: string = el.parentElement.getAttribute('id') ?? '';
        if (!filtersParentMarkUp.includes(parentId)) {
          filtersParentMarkUp += parentId;
          filtersCount++;
        }
      }
    });

    applicantCards.forEach(function (element) {
      if (selectedFilters.length) {
        let matchedFilters = 0;
        selectedFilters.forEach(function (selectedFilter: HTMLOptionElement) {
          const dataSelector: string = selectedFilter.dataset.filter ?? '';

          if (
            element.hasAttribute(dataSelector) &&
            selectedFilter.value === element.getAttribute(dataSelector)
          ) {
            matchedFilters++;
          }
        });
        if (matchedFilters !== filtersCount) {
          element.classList.add('hide-applicant');
        } else {
          element.classList.remove('hide-applicant');
        }
      } else {
        //reset filters
        element.classList.remove('hide-applicant');
      }
    });
  };

  const applicantCards: NodeListOf<HTMLElement> = document.querySelectorAll(
    '.wp-block-menlo-applicant-story-card',
  );

  if (displayApplicantsFilters && applicantCards.length) {
    const filtersContainer = document.createElement('div');
    filtersContainer.className = 'menlo-applicants-filters__container';
    filtersContainer.setAttribute('id', 'filters-per-row-' + filtersPerRow);

    const mcFiltersTitle = document.createElement('h3');
    mcFiltersTitle.append(filtersTitle);

    const mcFilters = document.createElement('div');
    mcFilters.className = 'menlo-applicants-filters';

    if (menloFilters?.length) {
      let parentCount = 0;
      /*eslint-disable @typescript-eslint/no-explicit-any */
      menloFilters.map(function (item: any) {
        parentCount++;
        const mcFilter = document.createElement('select');
        mcFilter.className = 'menlo-applicants-filter';
        mcFilter.setAttribute('id', 'filter-parent__' + parentCount);

        const filterLabel = document.createElement('option');
        filterLabel.className = 'menlo-filter__label';
        filterLabel.setAttribute('value', 'default');
        filterLabel.append(item.filter_name);

        if (item.filter_components.length) {
          mcFilter.append(filterLabel);

          item.filter_components.map(function (component: any) {
            const inputValue = convertFilterName(component.filter_component);
            const dataFilter = 'data-filter-' + convertFilterName(item.filter_name);

            //check if applicant with this filter exists
            const applicantWithFilter = document.querySelector(
              '.wp-block-menlo-applicant-card[' + dataFilter + '="' + inputValue + '"]',
            );

            if (applicantWithFilter) {
              const filterComponent = document.createElement('option');
              filterComponent.setAttribute('value', inputValue);
              filterComponent.setAttribute('data-filter', dataFilter);
              filterComponent.append(component.filter_component);

              mcFilter.append(filterComponent);
            }
          });
        }

        mcFilter.addEventListener('change', function () {
          updateFontWeight(this);
          updateFiltersAvailability();
        });

        mcFilters.append(mcFilter);
      });

      //add more elements to have a full row
      const filtersCount = parseInt(menloFilters.length);
      const lastRowElements = filtersCount % filtersPerRow;
      if (lastRowElements > 0) {
        const moreElements = filtersPerRow - lastRowElements;
        for (let i = 1; i <= moreElements; i++) {
          const hiddenFilter = document.createElement('select');
          hiddenFilter.classList.add('menlo-applicants-filter', 'hidden');
          hiddenFilter.setAttribute('style', 'visibility:hidden');
          mcFilters.append(hiddenFilter);
        }
      }

      const filtersBtn = document.createElement('div');
      filtersBtn.className = 'mc-filters-btn';

      const applyFiltersBtn = document.createElement('a');
      applyFiltersBtn.setAttribute('href', '#');
      applyFiltersBtn.append(applyFiltersText);

      const resetFiltersBtn = document.createElement('a');
      resetFiltersBtn.setAttribute('href', '#');
      resetFiltersBtn.append(resetFiltersText);

      applyFiltersBtn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopImmediatePropagation();
        applyFilters();
      });
      resetFiltersBtn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopImmediatePropagation();
        resetFilters();
      });

      filtersBtn.append(resetFiltersBtn, applyFiltersBtn);

      //add more elements to have a full row
      const moreElements = filtersPerRow - 2;
      for (let i = 1; i <= moreElements; i++) {
        const hiddenButton = document.createElement('a');
        hiddenButton.className = 'hidden';
        hiddenButton.setAttribute('style', 'visibility:hidden');
        filtersBtn.append(hiddenButton);
      }

      filtersContainer.append(mcFiltersTitle, filtersBtn, mcFilters);
    }

    const parentEl = applicantCards[0].parentNode;
    if (parentEl) {
      parentEl.insertBefore(filtersContainer, applicantCards[0]);
    }
  }
}
